import React from 'react';

export default function MaterialIcon({icon, size, onClick, readOnly}) {
    return (
        <i className={"material-icons"  + (readOnly ? " disabled" : "")} style={{fontSize: size + "px"}}
           onClick={onClick ? () => onClick() : undefined}>{icon}</i>
    )
}